import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { writeAuthReturnLocation } from "../../domain/auth/authReturnLocation";
import TRAIcon from "../icons/TRAIcon";
import { resolveActiveNavId, resolvePlatformNavItems } from "./platformNavItems";
import { navItemLabel, useCompactNavLabel } from "./useCompactNavLabel";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/** Desktop center nav links inside the top header. */
export default function TopNavigation({ items, className }) {
  const { pathname } = useLocation();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const compact = useCompactNavLabel();
  const navItems = items ?? resolvePlatformNavItems(isAuthenticated);
  const activeId = resolveActiveNavId(pathname);

  return (
    <nav className={cn(styles.topNav, className)} aria-label="Primary">
      {navItems.map((item) => {
        const active = item.id === activeId;
        const signIn = item.to === "/sign-in";
        return (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === "/"}
            state={signIn ? { from: location } : undefined}
            className={cn(styles.topNavLink, active && styles.topNavLinkActive)}
            aria-current={active ? "page" : undefined}
            aria-label={item.label}
            onClick={
              signIn
                ? () => {
                    writeAuthReturnLocation(location);
                  }
                : undefined
            }
          >
            <TRAIcon name={item.icon} size="sm" />
            <span>{navItemLabel(item, compact)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
